<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Customers</h4>
    </div>

    <div
      class="panel-body"
      style="display: block"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_credit: 'add_credit',
            add_customer: 'add_customer',
          }"
          :hideBranch="true"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :showCreateCustomerButton="true"
          :openCreateCustomerModal="openCreateCustomerModal"
          :addCreatCreditButton="true"
          :openCreatCreditModal="openCreatCreditModal"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        >
          <template v-slot:custom-filter>
            <v-flex
              sm12
              md4
              lg3
              xl3
              class="px-3"
            >
              <v-select
                :items="verifiedList"
                v-model="tableData.phone_verified"
                label="Verify Filter"
                @input="getResults()"
              ></v-select>
            </v-flex>
          </template>
        </preDatatableComponent>
        <div class="col-xs-12">
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.user_id"
              >
                <td>{{ r.user_id }}</td>
                <td>
                  {{ r.full_name }}
                  <div
                    v-if="r.phone_verified"
                    class="verify-badge tooltip-container"
                  >
                    <div class="tooltip-content">
                      Verified at {{ r.verified_at | moment('YYYY-MM-DD hh:mm A') }}
                    </div>
                  </div>
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>{{ r.email }}</td>
                <td class="ws-nowrap">
                  {{ r.phone_number }}
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="ws-nowrap">
                  {{ r.phone_number_2 }}
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number_2" />
                </td>
                <td>{{ r.city_name }}</td>
                <td v-if="r.is_blocked === '0'">
                  <span class="label bg-green-600">Active</span>
                </td>
                <td v-else>
                  <span class="label bg-warning">Block</span>
                </td>
                <td>{{ r.address }}</td>
                <td>${{ r.credit }}</td>
                <td
                  v-if="$_has_perm('edit_customer')"
                  style="padding-left: 5px; padding-right: 5px"
                >
                  <a
                    style="color: #01579b"
                    tooltip="Edit Customer"
                    @click="openEditCustomerModal(r)"
                  >
                    <i class="material-icons">edit</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('view_customer_transaction')"
                  style="padding-left: 0px; padding-right: 5px"
                >
                  <a
                    style="color: #555"
                    tooltip="Customer transaction"
                    @click="customerTransaction(r.user_id, r.full_name)"
                  >
                    <i class="material-icons">swap_horiz</i>
                  </a>
                </td>
                <td
                  v-if="r.is_blocked === '0' && r.status !== 'admin' && $_has_perm('block_unblock_customer')"
                  style="padding-left: 0px; padding-right: 5px"
                >
                  <a
                    style="color: #ff5722"
                    tooltip="Block This User"
                    @click="blockUser(r.user_id)"
                  >
                    <i class="material-icons">lock_outline</i>
                  </a>
                </td>
                <td
                  v-else-if="r.status !== 'admin' && $_has_perm('block_unblock_customer')"
                  style="padding-left: 0px; padding-right: 5px"
                >
                  <a
                    style="color: #7cb342"
                    tooltip="Unblock This User"
                    @click="unblockUser(r.user_id)"
                  >
                    <i class="material-icons">lock_open</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    phone_number="error"
                    :value="alertValue"
                  > No Results Found </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>
          <table class="table">
            <tr>
              <td style="width: 100%; padding-top: 5px">
                <span style="float: right; font-weight: bold; padding-right: 30px">Total income &nbsp; ${{ totalCredit }}</span>
              </td>
            </tr>
          </table>

          <create-user
            :createCustomerModal="createCustomerModal"
            :createCustomer="createCustomer"
            :citiesList="citiesList"
            :addData="addData"
            :checkAlert="checkAlert"
            :validationError="validationError"
            :phoneError="phoneError"
            :emailError="emailError"
            :phoneNumberError="phoneNumberError"
            :closeCreateCustomerModal="closeCreateCustomerModal"
            :defaultPriceData="defaultPriceData"
          ></create-user>

          <edit-customer
            :editCustomerModal="editCustomerModal"
            :editCustomer="editCustomer"
            :editCustomerData="editCustomerData"
            :citiesList="citiesList"
            :checkAlert="checkAlert"
            :validationError="validationError"
            :emailError="emailError"
            :backendError="backendError"
            :closeEditCustomerModal="closeEditCustomerModal"
          ></edit-customer>

          <customer-transactions
            :tranDialog="tranDialog"
            :customerId="customerId"
            :customerName="customerName"
            @close-dialog="tranDialog = false"
          />

          <creat-credit
            :createCreditModal="createCreditModal"
            :createCredit="createCredit"
            :addData="addCreditData"
            :checkAlert="checkAlert"
            :closeCreatCreditModal="closeCreatCreditModal"
            :customers="customers"
            :currentExchangeRate="currentExchangeRate"
            :load="load"
          ></creat-credit>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination'
import preDatatableComponent from '../preDatatableComponent'
import DatatableVue from '../Datatable'
import createUser from './createUser.vue'
import editCustomer from './editCustomer.vue'
// import mobileDatatable from '../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'
import customerTransactions from './customerTransactions.vue'
import createCredit from './user_credit/createCredit.vue'

export default {
  components: {
    customerTransactions,
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'create-user': createUser,
    'edit-customer': editCustomer,
    // 'mobile-datatable': mobileDatatable,
    'creat-credit': createCredit
  },
  created() {
    if (this.queryParameter === true) {
      if (
        window.location.search.replace('?name=', '') !== null ||
        window.location.search.replace('?name=', '') !== ''
      ) {
        let value = window.location.search.replace('?name=', '').replace(/%20/g, ' ')
        this.searchOneCol('full_name', value)
      }
    }
    this.getResults()
  },
  mounted() {
    this.perPageFix()
    this.getDefaultPrices()
    this.getCustomer()
    this.getCityList()
    this.getCurrentExchangeRate()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      {
        label: 'ID',
        text: 'ID',
        value: '1',
        sortable: true,
        searchable: true,
        name: 'user_id'
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '2',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: 'Customer Note',
        text: 'Customer Note',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'customer_note'
      },
      {
        label: 'Email',
        text: 'Email',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'email'
      },
      {
        label: 'Phone Number',
        text: 'Phone Number',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'phone_number'
      },
      {
        label: 'Phone Number 2',
        text: 'Phone Number 2',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'phone_number_2'
      },
      {
        label: 'City',
        text: 'City',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'city_name'
      },
      {
        label: 'Status',
        text: 'Status',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'is_blocked'
      },
      {
        label: 'Address',
        text: 'Address',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'address'
      },
      {
        label: 'Credit',
        text: 'Credit',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'credit'
      }
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      load: false,
      getCustomerUrl: 'api/get-customer-to-select',
      url: 'api/get-customer',
      createCustomerUrl: 'api/customer',
      editCustomerUrl: 'api/update-customer',
      getDefaultPriceUrl: 'api/default_price',
      blockUserUrl: 'api/users',
      unBlockUserUrl: 'api/users',
      createCustomerModal: false,
      tranDialog: false,
      tranData: [],
      customerId: 0,
      customerName: '',
      the_user_id: '',
      alertValue: false,
      checkAlert: false,
      errorAlert: false,
      validationError: false,
      phoneError: false,
      editCustomerModal: false,
      backendError: false,
      emailError: '',
      phoneNumberError: '',
      btnsave: true,
      totalCredit: 0,
      queryParameter: true,
      filterMade: false,
      totalResult: 0,
      currentExchangeRate: 0,
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'user_id',
      sortOrders: sortOrders,
      createCreditModal: false,
      customersResult: [],
      customers: [],
      addCreditData: {},
      citiesList: [],
      defaultPriceData: {
        customer_price_per_weight_usa: '',
        customer_price_per_weight_turkey: '',
        customer_base_qtt_charge_turkey: '',
        customer_base_qtt_charge_usa: '',
        customer_other_qtt_charge_turkey: '',
        customer_other_qtt_charge_usa: ''
      },
      addData: {
        full_name: '',
        customer_note: '',
        email: '',
        password: '',
        confirm_password: '',
        phone_number: '',
        phone_number_2: '',
        city_id_fk: null,
        address: '',
        item_weight_price_usa: '',
        item_weight_price_turkey: '',
        quantity_charge_base_turkey: '',
        quantity_charge_other_turkey: '',
        quantity_charge_base_usa: '',
        quantity_charge_other_usa: ''
      },
      editCustomerData: {
        full_name: '',
        customer_note: '',
        email: '',
        phone_number: '',
        phone_number_2: '',
        city_id_fk: null,
        address: '',
        item_weight_price_usa: '',
        item_weight_price_turkey: '',
        quantity_charge_base_turkey: '',
        quantity_charge_other_turkey: '',
        quantity_charge_base_usa: '',
        quantity_charge_other_usa: '',
        new_password: null,
        phone_verified: false,
        base_phone_verified: false
      },
      resetPasswordData: {
        new_password: ''
      },
      verifiedList: [
        { text: 'All', value: null },
        { text: 'Verified', value: 1 },
        { text: 'Unverified', value: 0 }
      ],
      tableData: {
        per_page: 10,
        search: '',
        column: 'user_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        phone_verified: null
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    getCityList() {
      let token = localStorage.getItem('access_token')

      axios.get('api/city/list', {
        headers: { Authorization: 'Bearer ' + token }
      }).then((response) => {
        this.citiesList = response.data
      })
    },

    getCurrentExchangeRate() {
      let token = localStorage.getItem('access_token')

      axios.get('api/currency-rate/latest', {
        headers: { Authorization: 'Bearer ' + token }
      }).then((response) => {
        this.currentExchangeRate = response.data.ex_rate
      })
    },

    openCreatCreditModal() {
      this.createCreditModal = true
    },

    closeCreatCreditModal() {
      this.createCreditModal = false
      this.checkAlert = false
      this.clearCredit()
    },

    clearCredit() {
      this.addCreditData = {}
      this.$validator.reset()
    },

    createCredit() {
      this.load = true
      let token = localStorage.getItem('access_token')

      axios
        .post('api/credit_invoices', this.addCreditData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.checkAlert = true
          this.getResults()
          this.clearCredit()
          this.load = false
        })
        .catch(() => {
          this.checkAlert = true
          this.getResults()
          this.clearCredit()
          this.load = false
        })
    },

    getCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getCustomerUrl, {
          params: this.customerParam,
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.customersResult = response.data.data

          this.customersResult.forEach((c) => {
            this.customers.push({
              text: c.full_name + ' - Tel: ' + c.phone_number,
              value: c.user_id
            })
          })
        })
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    sendToExport() {
      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/customer-export')
    },

    getDefaultPrices() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getDefaultPriceUrl, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          let result = response.data.data

          this.defaultPriceData.customer_base_qtt_charge_turkey =
            result[0].customer_base_qtt_charge_turkey
          this.defaultPriceData.customer_base_qtt_charge_usa =
            result[0].customer_base_qtt_charge_usa
          this.defaultPriceData.customer_other_qtt_charge_turkey =
            result[0].customer_other_qtt_charge_turkey
          this.defaultPriceData.customer_other_qtt_charge_usa =
            result[0].customer_other_qtt_charge_usa
          this.defaultPriceData.customer_price_per_weight_turkey =
            result[0].customer_price_per_weight_turkey
          this.defaultPriceData.customer_price_per_weight_usa =
            result[0].customer_price_per_weight_usa
        })
    },

    getResults(url = this.url) {
      let token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, {
          params: this.tableData,
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          let total = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            total = total + Number(this.apiResults[i].credit)
            this.totalResult += 1
          }
          this.totalCredit = total.toFixed(2)
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'user_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'user_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.filterTable(this.tableData.from_date, this.tableData.to_date)
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'user_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'user_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    openCreateCustomerModal() {
      this.createCustomerModal = true
    },

    closeCreateCustomerModal() {
      this.createCustomerModal = false
      this.validationError = false
      this.checkAlert = false
      this.clear()
    },

    customerTransaction(id, name) {
      this.customerName = name
      this.customerId = id
      this.tranDialog = true
    },

    blockUser(id) {
      let token = localStorage.getItem('access_token')
      axios
        .delete(this.blockUserUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          swal({
            title: 'Done',
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
          this.getResults()
        })
        .catch((error) => {
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    unblockUser(id) {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.unBlockUserUrl + '/' + id + '/unblock', '', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          swal({
            title: 'Done',
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
          this.getResults()
        })
        .catch((error) => {
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    clear() {
      this.addData.full_name = ''
      this.addData.note = ''
      this.addData.email = ''
      this.addData.password = ''
      this.addData.confirm_password = ''
      this.addData.phone_number = ''
      this.addData.phone_number_2 = ''
      this.addData.city_id_fk = null
      this.addData.address = ''
      this.addData.item_weight_price_usa = ''
      this.addData.item_weight_price_turkey = ''
      this.addData.quantity_charge_base_turkey = ''
      this.addData.quantity_charge_other_turkey = ''
      this.addData.quantity_charge_base_usa = ''
      this.addData.quantity_charge_other_usa = ''
      this.$validator.reset()
    },

    createCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .post(this.createCustomerUrl, this.addData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          swal('Success', 'Added successfully', 'success')
          this.getResults()
          this.clear()
          this.createCustomerModal = false
        })
        .catch((error) => {
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    openEditCustomerModal(r) {
      this.the_user_id = r.user_id
      this.editCustomerData = {
        ...r,
        base_phone_verified: r.phone_verified
      }
      this.editCustomerModal = true
    },

    closeEditCustomerModal() {
      this.editCustomerModal = false
      this.validationError = false
      this.backendError = false
      this.checkAlert = false
    },

    editCustomer() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editCustomerUrl + '/' + this.the_user_id, this.editCustomerData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.editCustomerModal = false
          swal('Success', 'Updated successfully', 'success')
          this.getResults()
        })
        .catch((error) => {
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
.verify-badge {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #42a5f5, #007aff);
  font-size: 10px;
  font-weight: bold;
}

.verify-badge::before {
  color: #fff;
  content: '✔';
  font-size: 10px;
  line-height: 1;
}

.tooltip-container {
  position: relative;
}

.tooltip-container:hover .tooltip-content {
  visibility: visible;
  opacity: 1;
}

.tooltip-content {
  visibility: hidden;
  opacity: 0;
  transition: all 0.3 linear;
  position: absolute;
  top: -10px;
  left: 20px;
  z-index: 1000;
  font-size: 12px;
  font-weight: normal;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 6px !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 8px 12px;
  min-width: 210px;
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/regularUser.vue